import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { API_IDENTIFICATION_URL, GA_EVENT_CATEGORY } from './constants'

export const IS_LOADING = 'IS_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const IDENTIFICATION_INIT_LOADING = 'IDENTIFICATION_INIT_LOADING'
export const IDENTIFICATION_INIT_DONE = 'IDENTIFICATION_INIT_DONE'
export const IDENTIFICATION_ERROR = 'IDENTIFICATION_ERROR'
export const IDENTIFICATION_SUCCESS = 'IDENTIFICATION_SUCCESS'

export function isLoading(state) {
  return {
    type: IS_LOADING,
    payload: state,
  }
}

export function setError(errorMessage) {
  return {
    type: SET_ERROR,
    payload: errorMessage,
  }
}
export function identificationInitLoading() {
  return {
    type: IDENTIFICATION_INIT_LOADING,
  }
}

export function identificationInitDone(verificationToken) {
  return {
    type: IDENTIFICATION_INIT_DONE,
    verificationToken,
  }
}

export function identicationSetError(message) {
  return {
    type: IDENTIFICATION_ERROR,
    payload: message,
  }
}

export function identificationSuccess(nextStage) {
  return {
    type: IDENTIFICATION_SUCCESS,
    payload: nextStage,
  }
}

export function identificationInit() {
  return (dispatch) => {
    dispatch(identificationInitLoading())
    axios
      .get(API_IDENTIFICATION_URL)
      .then((response) => {
        if (response.data && response.data.success) {
          dispatch(identificationInitDone(response.data.vrf_token))
          gaEvent('Success', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Identification Init - Success',
            non_interaction: true,
          })
        } else {
          dispatch(setError(true))
          dispatch(isLoading(false))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Identification Init - Backend Error',
            non_interaction: true,
          })
        }
      })
      .catch((error) => {
        if (error.response && error.response.message) {
          dispatch(setError(error.response.message))
          dispatch(isLoading(false))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Identification Init - Backend Error',
            non_interaction: true,
          })
        } else {
          dispatch(setError(true))
          dispatch(isLoading(false))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Identification Init - Network Error',
            non_interaction: true,
          })
        }
      })
  }
}

export function identificationComplete(veritificationToken) {
  return (dispatch) => {
    const data = {
      vrf_token: veritificationToken,
    }
    axios
      .post(API_IDENTIFICATION_URL, data)
      .then((response) => {
        if (response.data.success) {
          dispatch(identificationSuccess(response.data.next))
          gaEvent('Success', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Identification Complete - Success',
            non_interaction: true,
          })
        } else {
          dispatch(identicationSetError(true))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Identification Complete - Backend Error',
            non_interaction: true,
          })
        }
      })
      .catch(() => {
        dispatch(identicationSetError(true))
        gaEvent('Error', {
          event_category: GA_EVENT_CATEGORY,
          event_label: 'Identification Complete - Network Error',
          non_interaction: true,
        })
      })
  }
}



// WEBPACK FOOTER //
// ./containers/stages/IdentificationStage/actions.js